<template>
  <div class="page-notfound">

    <top-subpage-section>
    </top-subpage-section>

    <div-container>
      <div class="hero is-primary" style="margin-top:100px;">
        <div class="hero-body content has-text-centered">
          <div style="padding:30px;">
            <h1 class="title">
              Uh oh
            </h1>
            <h2 class="subtitle">
              404 Page Not Found
            </h2>
          </div>
        </div>
      </div>
    </div-container>
  </div>
</template>

<script>
import DivContainer from '@/components/DivContainer'
import TopSubpageSection from '@/components/TopSubpageSection'
export default {
  name: 'notfound',
  components: {
    DivContainer,
    TopSubpageSection
  },
  data () {
    return {
      isDesktop: true
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-notfound {
  position: relative;
  background-color: $color-beige;

  .hero {
    &.is-primary {
      background-color: transparent;

      .title, .subtitle {
        color: $color-darkbrown;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// NotFound.vue?70660eda